import { ClerkWrapper } from "@/components/auth/clerk-wrapper";
import { HeroImage } from "@/components/auth/hero-image";
import { OnboardingPage } from "@/components/auth/onboarding-page";
import { SignIn } from "@clerk/react";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/signin")({
  component: RouteComponent,
  beforeLoad: async ({ context, search }) => {
    if (context.auth.isSignedIn) {
      if (context.auth.orgId) {
        throw redirect({ to: search.redirect_url ?? "/" });
      }
      throw redirect({ to: "/onboarding/organization", search });
    }
  },
  loader: async () => {
    return { crumb: "Sign in" };
  },
});

function RouteComponent() {
  return (
    <OnboardingPage
      page={
        <ClerkWrapper>
          <SignIn
            appearance={{
              options: { logoPlacement: "none" },
              variables: { fontSize: { md: "0.875rem" } },
            }}
          />
        </ClerkWrapper>
      }
      hero={
        <HeroImage
          copy="Track and collect your unpaid invoices with Trove"
          url="/assets/onboarding-1.svg"
        />
      }
      sx={{ left: 0, right: 0 }}
    />
  );
}
